import { useEffect, useState } from "react";
import { connect } from "react-redux";
import toast from "react-hot-toast";
import { Collapse } from "@mui/material";

import CustomInputV2 from "../../../common/CustomInputV2";
import CustomActionButton from "../../../common/CustomActionButton";
import CustomSelect from "../../../common/CustomSelect";
import PromptProperties from "./PromptProperties";

import { allFieldsHaveValue } from "../../../utils";
import { AddPrompt } from "../../../redux/prompt/actions";

import usePrompt from "../../../hooks/usePrompt";

function NewPromptDetails(props) {
    const { arrangePromptValues } = usePrompt();

    const [promptOutput, setPromptOutput] = useState(null);
    const [openSystemPrompt, setOpenSystemPrompt] = useState(false);
    const [temporaryPrompt, setTemporaryPrompt] = useState("");
    const [promptDetails, setPromptDetails] = useState({
        name: "",
        text: "",
        type: "user",
        class: "raw",
        systemPrompt: null,
        newSystemPrompt: null,
        properties: [
            {
                name: "Full Name",
                key: "fullName",
                type: "text",
                note: "user's full name",
                value: "",
            },
            {
                name: "Age",
                key: "age",
                type: "text",
                note: "user's age",
                value: "",
            }
        ],
    });

    const handleChange = (e) => {
        setPromptDetails({
            ...promptDetails,
            [e.target.name]: e.target.value,
        });
    }

    const handleSystemPromptChange = (e, key) => {
        if (promptDetails?.systemPrompt == "new") {
            setPromptDetails({
                ...promptDetails,
                newSystemPrompt: {
                    ...promptDetails?.newSystemPrompt,
                    [key]: e.target.value
                },
            });
        } else {

        }

    }

    const systemPromptsOptions = props?.Prompt?.systemPrompts?.map((prompt) => {
        return {
            label: prompt.name,
            value: prompt.id,
        }
    });


    const selectedSystemPrompt = props?.Prompt?.systemPrompts?.find((prompt) => prompt.id == promptDetails?.systemPrompt);


    return (
        <>
            <div id="prompt-details" className="pd-add">
                <div className="pd-left">
                    <PromptProperties promptDetails={promptDetails} setPromptDetails={setPromptDetails} handleChange={handleChange} />
                </div>

                <div className="pd-right">

                    <div className="row clickable" onClick={(e) => {
                        if (e.target?.className?.includes("clickable")) {
                            setOpenSystemPrompt(!openSystemPrompt);
                        }
                    }}>
                        <div className="col-md-5 mb-4 clickable">
                            <h5>System Prompt</h5>
                            <CustomSelect name="systemPrompt" options={[{ label: "", value: "" }, ...systemPromptsOptions]} onChange={(e) => {
                                handleChange(e);
                                if (e.target.value === "new") {
                                    setOpenSystemPrompt(true);
                                }
                            }} />
                        </div>
                        <div className="col-md-12 mb-4 clickable">
                            <Collapse in={openSystemPrompt} timeout="auto" unmountOnExit>

                                <>
                                    {
                                        promptDetails?.systemPrompt === "new" &&
                                        <div className="col-md-8 mb-4">
                                            <h5>System Prompt Name</h5>
                                            <CustomInputV2
                                                required={true}
                                                value={promptDetails?.systemPrompt == "new" ? promptDetails?.newSystemPrompt?.name : selectedSystemPrompt?.name}
                                                type="text"
                                                onChange={(e) => {
                                                    handleSystemPromptChange(e, "name");
                                                }}
                                                name="name"
                                            />

                                        </div>
                                    }
                                    <div className="col-md-12 mb-4">
                                        <h5>System Prompt</h5>
                                        <pre className="prompt-pre" contentEditable={promptDetails?.systemPrompt == "new"} onInput={(e) => {
                                            handleSystemPromptChange(e, "text");
                                        }}>
                                            {promptDetails?.systemPrompt == "new" ? promptDetails?.newSystemPrompt?.text : selectedSystemPrompt?.text}
                                        </pre>
                                    </div>
                                </>
                            </Collapse>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-8 mb-4">
                            <h5>Name</h5>
                            <CustomInputV2
                                required={true}
                                value={promptDetails?.name}
                                type="text"
                                onChange={handleChange}
                                name="name"
                            />

                        </div>

                        <div className="col-md-4 mb-4">
                            <h5>Class</h5>
                            <CustomSelect name="type" options={[
                                { label: "Chat Completion", value: "chat-completion" },
                                { label: "Program Embeddings", value: "program-embeddings" },
                            ]} onChange={handleChange} />
                        </div>

                        <div className="col-md-12 mb-4">
                            <h5>Prompt</h5>
                            <pre className="prompt-pre" contentEditable={true} onInput={(e) => {
                                setTemporaryPrompt(e.target.outerText);
                            }}>
                                {promptDetails?.text}
                            </pre>
                        </div>

                        <div className="col-md-12">
                            <h5>Preview</h5>
                            <pre className="prompt-pre">
                                {
                                    arrangePromptValues(temporaryPrompt, promptDetails?.properties)
                                }
                            </pre>
                        </div>

                        <div className="col-md-12">
                            <div id="prompt-actions">

                                <CustomActionButton size="small" disabled={!allFieldsHaveValue({
                                    name: promptDetails?.name,
                                    text: temporaryPrompt,
                                    type: promptDetails?.type,
                                    class: promptDetails?.class,
                                })} action={async () => {

                                    const toastID = toast.loading("Adding Prompt...");
                                    const res = await props.AddPrompt({
                                        name: promptDetails?.name,
                                        text: temporaryPrompt,
                                        class: promptDetails?.class,
                                        type: promptDetails?.type,
                                        props: JSON.stringify(promptDetails?.properties),
                                        system_prompt: promptDetails?.systemPrompt ? promptDetails?.systemPrompt * 1 : null,
                                    });

                                    if (res) {
                                        toast.success("Prompt Added", {
                                            id: toastID,
                                        });
                                        props?.exit();
                                        setPromptDetails({
                                            name: "",
                                            text: "",
                                            type: "user",
                                            class: "raw",
                                        });

                                    } else {
                                        toast.error("Failed to add prompt", {
                                            id: toastID,
                                        });
                                    }
                                    return res || false;
                                }}>
                                    Add
                                </CustomActionButton>

                            </div>
                        </div>
                    </div>
                    {
                        promptOutput &&
                        <div className="row">
                            <div className="col-md-12">
                                <h5>Output</h5>
                                <pre className="prompt-pre">
                                </pre>
                            </div>
                        </div>
                    }

                </div>

            </div>
        </>
    );
}


const mapStateToProps = (state) => ({
    Prompt: state.Prompt,
})

export default connect(mapStateToProps, {
    AddPrompt,
})(NewPromptDetails);
